import { Spinner } from '@cian/ui-kit';
import * as React from 'react';
import { TPaymentSummaryWithDiscount } from 'shared/types/dailyrent/dailyrent';

import * as styles from './BookingInfo.css';
import { Sections } from './components';

interface IBookingInfoConstructorProps {
  paymentSummary: TPaymentSummaryWithDiscount;
  isLoading: boolean;
}

export const BookingInfo = ({ paymentSummary, isLoading }: IBookingInfoConstructorProps) => {
  return (
    <div className={styles['block']} data-testid="dailyrent-booking-info">
      {isLoading && (
        <div className={styles['spinner']}>
          <Spinner size={20} />
        </div>
      )}
      <Sections>{[paymentSummary]}</Sections>
    </div>
  );
};
